<div id="app">
    <app-sidebar *ngIf="!isUnauthorized && !isLoading"></app-sidebar>

    <div id="layout" [ngClass]="isSidebarCollapsed ? 'collapsed-sidebar' : 'expanded-sidebar'">
        <div id="header-container" *ngIf="!isUnauthorized && !isLoading">
            <app-header></app-header>

            <div id="breadcrumbs-container" *ngIf="!isUnauthorized && !isLoading">
                <app-breadcrumbs></app-breadcrumbs>
            </div>
        </div>

        <div id="content">
            <div id="app-loader" *ngIf="isLoading">
                <app-loader [globalLoader]="true"></app-loader>
            </div>
            <router-outlet></router-outlet>
            <app-error-page *ngIf="hasError && !isUnauthorized"></app-error-page>
            <app-unauthorized-page *ngIf="isUnauthorized"></app-unauthorized-page>
        </div>

        <div id="app-footer">
            <app-footer></app-footer>
        </div>
    </div>

    <div id="mobile-footer">
        <app-mobile-menu></app-mobile-menu>
    </div>
</div>

<p-toast
    id="error-messages-anchor"
    position="top-center"
    [key]="toasterPositions.TOP_CENTER"
    [preventOpenDuplicates]="true">
</p-toast>
<p-toast
    id="warning-success-messages-anchor"
    position="bottom-right"
    [key]="toasterPositions.BOTTOM_RIGHT"
    [preventOpenDuplicates]="true">
</p-toast>
